import { render, staticRenderFns } from "./layout-cooperation-main.vue?vue&type=template&id=89321932&scoped=true"
import script from "./layout-cooperation-main.vue?vue&type=script&lang=js"
export * from "./layout-cooperation-main.vue?vue&type=script&lang=js"
import style0 from "./layout-cooperation-main.vue?vue&type=style&index=0&id=89321932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89321932",
  null
  
)

export default component.exports